import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "jalali-moment";
import { Fade } from "react-awesome-reveal";
import AnimateHeight from "react-animate-height";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import { genderConverter, getAgeJalali } from "../../utils/Functions";
import useStore from "../../features/store";
import Loading from "../../components/common/loading";
import ProfileIcon from "../../assets/icons/profile.svg";
import ManAvatar from "../../assets/icons/avatar-man.png";
import WomanAvatar from "../../assets/icons/avatar-woman.png";
import EditIcon from "../../assets/icons/edit.svg";
import Arrow from "../../assets/icons/arrowLeft.svg";
import subordinateUsers from "../../assets/images/subordinate-users.png";
import checkupHistory from "../../assets/images/checkup-history.png";

const Profile = () => {
  const { isLoadingProfile, profile, transactions, fetchTransactions }: any =
    useStore();
  const [height, setHeight] = useState<any>("auto");

  useEffect(() => {
    if (!transactions) fetchTransactions();
  }, [transactions]);

  const UserInfo = () => {
    return (
      <div className="relative flex-1 h-full flex flex-col items-start w-full">
        <div className="relative flex-1 h-full flex flex-col w-full">
          <div className="w-full flex flex-col lg:flex-row justify-between gap-3 lg:gap-5 w-full">
            <Link
              to="/records"
              className="relative bg-pr_yellow flex-1 overflow-hidden pt-10 px-5 lg:p-10 pb-28 rounded-xl flex-1 flex flex-col items-start"
            >
              <img
                src={checkupHistory}
                className="absolute left-0 -bottom-5 h-[150px]"
              />
              <h3 className="font-rokh font-[900] text-2xl">
                آزمایش‌های <br /> ثبت‌شده
              </h3>
              <h4 className="mt-4 mb-11 bg-white px-3 text-sm rounded-full w-auto font-rokh font-[700] pt-[5px]">
                {profile?.test_count} مورد
              </h4>
            </Link>

            <Link
              to="/subcategory-users"
              className="relative bg-pr_green flex-1 pt-10 px-5 lg:p-10 pb-28 rounded-xl flex-1 flex flex-col items-start"
            >
              <img
                src={subordinateUsers}
                className="absolute -left-3 -bottom-6 h-[160px]"
              />
              <h3 className="font-rokh font-[900] text-2xl">
                کاربران <br />
                زیرمجموعه
              </h3>
              <h4 className="mt-4 mb-11 bg-white px-3 text-sm rounded-full w-auto font-rokh font-[700] pt-[5px]">
                {profile?.temp_user_count} نفر
              </h4>
            </Link>
          </div>
        </div>
        <Link
          to="/profile/transactions"
          className="relative w-full bg-pr_red flex-1 overflow-hidden mt-5 pt-10 px-5 lg:p-10 pb-28 rounded-xl flex-1 flex flex-col items-start"
        >
          <h3 className="font-rokh font-[900] text-2xl">
            تراکنش‌های <br /> انجام‌شده
          </h3>
          <h4 className="mt-4 mb-11 bg-white px-3 text-sm rounded-full w-auto font-rokh font-[700] pt-[5px]">
            {transactions?.count} مورد
          </h4>
        </Link>
      </div>
    );
  };

  return (
    <div className="mt-10">
      <div className="flex flex-col lg:flex-row lg:gap-5 w-full">
        <div className="bg-pr_blue p-10 rounded-xl flex-1">
          {isLoadingProfile ? (
            <Loading />
          ) : (
            <Fade triggerOnce>
              <div className="flex items-start justify-between">
                <div>
                  <h2 className="font-rokh font-[900] text-2xl">
                    {profile?.user.first_name ?? ""} <br />
                    {profile?.user.last_name ?? ""}
                  </h2>
                  <span className="font-rokh font-[700] mt-1">
                    کاربر بادی‌بان
                  </span>
                </div>
                <Link
                  to="/profile/update"
                  className="bg-white rounded-full p-3"
                >
                  <img src={EditIcon} className="w-7" alt="ویرایش" />
                </Link>
              </div>
              <div className="flex items-center justify-center mt-1">
                <div
                  className={`w-[200px] h-[200px] rounded-full border-[14px] border-white bg-pr_primary ${
                    profile?.gender === "UNKNOWN" ? "p-[.4rem]" : "p-0"
                  }`}
                >
                  <img
                    src={
                      profile?.gender === "FEMALE"
                        ? WomanAvatar
                        : profile?.gender === "MALE"
                        ? ManAvatar
                        : ProfileIcon
                    }
                    alt="پروفایل"
                    className="w-full h-full"
                  />
                </div>
              </div>

              <div className="flex items-center justify-between mt-10">
                <div className="flex flex-col items-center">
                  <span className="font-rokh font-[700] text-lg">سن</span>
                  <h4 className="font-rokh font-[900] text-xl mt-2">
                    {profile?.birth_day
                      ? `${getAgeJalali(profile?.birth_day)} سال`
                      : "نامشخص"}{" "}
                  </h4>
                </div>
                <div className="flex flex-col items-center">
                  <span className="font-rokh font-[700] text-lg">جنسیت</span>
                  <h4 className="font-rokh font-[900] text-xl mt-2">
                    {genderConverter(profile?.gender)}
                  </h4>
                </div>
                <div className="flex flex-col items-center">
                  <span className="font-rokh font-[700] text-lg">
                    تاریخ عضویت
                  </span>
                  <h4 className="font-rokh font-[900] text-xl mt-2">
                    {moment(profile?.created_at).format("jYYYY/jMM")}
                  </h4>
                </div>
              </div>
            </Fade>
          )}
        </div>

        <div className="flex-1 flex flex-col gap-5">
          <Fade triggerOnce>
            <div className="hidden lg:flex">
              <UserInfo />
            </div>
          </Fade>
        </div>
      </div>

      <div className="relative overflow-hidden bg-pr_purple mt-5 p-6 rounded-xl">
        <div className="flex items-end justify-between mt-3">
          <div>
            <h6 className="font-rokh font-[900] text-xl">تسک‌ها</h6>
            <p className="font-rokh font-[700]">
              برای تکمیل شدن پروفایلت این‌کارها رو انجام بده
            </p>
          </div>
        </div>

        <AnimateHeight id="example-panel" duration={500} height={height}>
          <div className="mt-10 pb-10">
            {!profile?.has_password && (
              <Link
                to="/profile/password"
                className="bg-white px-3 py-1 my-2 rounded-lg flex items-center justify-between"
              >
                <div>
                  <h5 className="font-rokh font-[700] mt-2">
                    انتخاب رمز عبور برای ورود به بادی‌بان
                  </h5>
                  <span className="font-rokh">
                    اگه برای پروفایلت یه رمز عبور تنظیم کنی، ورودت خیلی راحت‌تر
                    می‌شه.
                  </span>
                </div>
                <button>
                  <HiOutlineArrowLongLeft size={26} />
                </button>
              </Link>
            )}

            {(!profile?.birth_day || profile?.gender === "UNKNOWN") && (
              <Link
                to="/profile/update"
                className="bg-white px-3 py-1 my-2 rounded-lg flex items-center justify-between"
              >
                <div>
                  <h5 className="font-rokh font-[700] mt-2">تکمیل پروفایل</h5>
                  <span className="font-rokh">
                    برای تحلیل آزمایش‌ها ما به سن و جنسیتت احتیاج داریم.
                  </span>
                </div>
                <button>
                  <HiOutlineArrowLongLeft size={26} />
                </button>
              </Link>
            )}

            {profile?.test_count === 0 && (
              <Link
                to="/test-registration"
                className="bg-white px-3 py-1 my-2 rounded-lg flex items-center justify-between"
              >
                <div>
                  <h5 className="font-rokh font-[700] mt-2">
                    ثبت اولین آزمایش
                  </h5>
                  <span className="font-rokh">
                    بادی‌بان منتظرته تا آزمایشت رو بگیره و کامل‌ترین تحلیل ممکن
                    رو بهت تحویل بده!
                  </span>
                </div>
                <button>
                  <HiOutlineArrowLongLeft size={26} />
                </button>
              </Link>
            )}

            <Link
              to="/test-registration"
              className="bg-white px-3 my-2 py-1 rounded-lg flex items-center justify-between"
            >
              <div>
                <h5 className="font-rokh font-[700] mt-2">
                  ثبت نظر برای تحلیل یک آزمایش
                </h5>
                <span className="font-rokh">
                  اگه برای تحلیل آزمایشت نظر ثبت کنی به ما برای پیشرفتمون خیلی
                  کمک می‌کنی.
                </span>
              </div>
              <button>
                <HiOutlineArrowLongLeft size={26} />
              </button>
            </Link>

            <div className="bg-white px-3 my-2 py-1 rounded-lg flex items-center justify-between">
              <div>
                <h5 className="font-rokh font-[700] mt-2">دعوت از دوستان</h5>
                <span className="font-rokh">
                  به دوستات خبر بده بیان اینجا و ما رو بهشون معرفی کن! لطفا!
                </span>
              </div>
              <button>
                <HiOutlineArrowLongLeft size={26} />
              </button>
            </div>
          </div>
        </AnimateHeight>

        <div
          style={{
            background:
              height === "auto"
                ? "transparent"
                : "linear-gradient(0deg, rgba(221,227,255,1) 0%, rgba(221,227,255,0) 50%)",
          }}
          className={`absolute w-full ${
            height === "auto" ? "-bottom-full" : "bottom-0"
          } left-0 h-full flex items-end justify-center`}
        >
          <button
            className="bg-white w-10 h-10 rounded-full mb-2 flex items-center justify-center"
            aria-expanded={height !== 250}
            aria-controls="example-panel"
            onClick={() => {
              setHeight(height === 250 ? "auto" : 250);
            }}
          >
            <img
              src={Arrow}
              className={`duration-300 ${
                height === 250 ? "rotate-[270deg]" : "rotate-90"
              } `}
            />
          </button>
        </div>
      </div>

      {/* <div className="relative overflow-hidden bg-pr_primary mt-5 lg:mt-0 p-6 rounded-xl flex-1 h-full">
              <img
                src={VictoryHand}
                className="absolute -left-3 -bottom-3 w-[190px]"
              />

              <h6 className="font-rokh font-[900] text-[23px] lg:text-3xl mt-1 lg:mt-4 text-white">
                امتیاز کلی سلامت <br />
                بدن شما
              </h6>
              <h3
                className="text-right font-rokh text-[30px] font-[700] text-white mt-5"
                style={{ direction: "ltr" }}
              >
                <strong className="font-rokh text-[30px] font-[700]">68</strong>{" "}
                /100
              </h3>
            </div> */}

      <div className="flex lg:hidden my-5">
        <UserInfo />
      </div>
    </div>
  );
};

export default Profile;
